import * as angular from "angular";
import {IController, IWindowService} from "angular";
import {BringozToastService} from "../../services/bringoz-toast.service";
import {TranslationsService} from "../../angular/services/translations.service";
import {SiteContextService} from "../../services/site-context.service";

export class BringozLanguageSelectCtrl implements IController {
  isDisabled: boolean;

  public languages: any;
  public siteCountryCode: any;
  public selectedLanguage: any;
  public isOpen: any


  constructor(private commonsConstants, private triSettings, private $translate, private bringozToastService: BringozToastService,
              private $window: IWindowService, private translationsService: TranslationsService, private siteContextService: SiteContextService) {
    this.selectedLanguage = this.$translate.use();
    this.languages = this.triSettings.languages;
  }

  $onInit() {
  }

  onOpen() {
    this.isOpen = true;
  }

  onClose() {
    this.isOpen = false;
  }

  switchLanguage(languageKey) {
    if (languageKey) {
      this.$translate.use(languageKey)
        .then(() => {
          this.$window.localStorage.setItem('NG_TRANSLATE_LANG_KEY', languageKey);
          this.translationsService.setTranslations(languageKey, this.siteContextService.getSiteInfo().languageFlavor);
          const message = {
            body: 'LANGUAGE_CHANGED'
          };
          this.bringozToastService.info(message);
        });
    }
  }

}

angular
  .module('bringoz.admin.commons')
  .component('bringozLanguageSelect', {
    bindings: {
      isDisabled: '<?',
    },
    template: require('./bringoz-language-select.html').default,
    controller: BringozLanguageSelectCtrl
  });
